// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2GFbO","legacyBtn":"MutateMid_legacyBtn__37766"};